import React, { FC } from 'react'
import { SubHead } from '../../../../Headings/src/index'
import { OverlayDescriptionProps } from './OverlayDescription.types'
import { sanitizeHTML } from '../../../../../utils/common-utils'

export const OverlayDescription: FC<OverlayDescriptionProps> = props => {
  const {
    outerClasses,
    bgColor,
    textColor,
    alignment,
    textAlignment,
    description,
    descriptionClasses,
    heading,
    isPositionLeft,
  } = props
  return (
    <div className={`BannerOverlay--mainWrapper u-lg-flex ${alignment} ${outerClasses}`}>
      <div
        className={`BannerOverlay-description u-flex u-flexAlignItemsCenter ${bgColor} ${textAlignment}`}>
        <div
          className={`BannerOverlay-descriptionWrapper Content u-paddingVert5gu ${
            isPositionLeft ? 'u-paddingLeft0 u-paddingRight9gu' : 'u-paddingHoriz9gu'
          } ${textColor}`}>
          {heading && <SubHead classes={'u-textSizeMsrp9 u-textSecondary'} label={heading} />}
          {description && (
            <div
              className={`${descriptionClasses}`}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
